import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { filter, map, sumBy, find } from 'lodash';
import { connect } from 'react-redux';
import Fa from 'react-fontawesome';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import ProgressBar from '../../../../components/progress-bar';
import NumberDisplay from '../../../../components/number-display';

import {
  getCollectorStatsLoading,
  getCollectorStatsLoaded,
  getCollectorStatsData,
} from '../../../Dashboard/DashboardReducer';

import styles from './styles.css';

const STATS_TYPE_CURRENT = 'stats';
const STATS_TYPE_ALL = 'all';

class CollectorStats extends Component {
  constructor(props) {
    super(props);
    this.state = {
      type: STATS_TYPE_CURRENT,
    };
  }

  componentDidMount() {
    this.checkProps(this.props);
  }

  componentWillReceiveProps(nextProps) {
    if (!this.props.shouldFetch && nextProps.shouldFetch) {
      this.checkProps(nextProps);
    }
  }

  checkProps(props) {
    if (props.shouldFetch) {
      this.props.requestFetchCollectorStats(this.props.collector);
    }
  }

  renderNav() {
    const tabs = [
      { value: STATS_TYPE_CURRENT, label: 'Current Stats', description: 'Showing stats for current data set returned by the search.' },
      { value: STATS_TYPE_ALL, label: 'All Stats', description: 'Showing all stats from the survey collector.' },
    ];
    const activeTab = find(tabs, { value: this.state.type });
    return (
      <div>
        <ul className="nav nav-tabs nav-justified" style={{ marginBottom: '10px' }}>
          {tabs.map(tab => (
            <li key={tab.value} className={activeTab && activeTab.value === tab.value ? 'active' : ''}>
              <a onClick={(e) => { e.preventDefault(); this.setState({ type: tab.value }); }} href="">{tab.label}</a>
            </li>
          ))}
        </ul>
        {activeTab !== undefined && activeTab.description !== undefined &&
          <p>
            <em>{activeTab.description}</em>
          </p>
        }
      </div>
    );
  }

  render() {
    const {
      loading,
    } = this.props;
    if (loading) {
      return (
        <div className="well" style={{ margin: 0 }}>
          <div><em>calculating...</em></div>
          <ProgressBar />
        </div>
      );
    }
    const data = this.props.data && this.props.data[this.state.type] ? this.props.data[this.state.type].steps : [];
    const steps = filter(data, { isDisabled: false });

    const nav = this.renderNav();

    if (steps.length === 0) {
      return (
        <div>
          {nav}
          <div className="well" style={{ margin: 0 }}>No records found</div>
        </div>
      );
    }

    const rows = [];
    const totalComplete = sumBy(steps, 'completed');
    const firstStep = steps.length > 0 ? steps[0] : { total: 0 };

    let totalTerminate = 0;
    map(steps, (step) => {
      const openRates = step.total !== 0 ? (step.opened / step.total) * 100 : 0;
      const completeRates = step.total !== 0 ? (step.completed / step.total) * 100 : 0;
      totalTerminate += step.terminated !== undefined ? step.terminated : 0;
      
      rows.push((
        <tr key={`${step.id}-name`}>
          <th className={`text-center ${styles.heading}`} colSpan={3}>
            {step.name}
          </th>
        </tr>
      ));
      rows.push((
        <tr key={`${step.id}-head`}>
          <th>
            &nbsp;
          </th>
          <th className="text-right">Contacts</th>
          <th className="text-right">%</th>
        </tr>
      ));
      rows.push((
        <tr key={`${step.id}-total`}>
          <td>
            Requested:
          </td>
          <td className="text-right"><strong><NumberDisplay value={step.total} precision={0} /></strong></td>
          <td className="text-right">&nbsp;</td>
        </tr>
      ));
      rows.push((
        <tr key={`${step.id}-opened`}>
          <td>
            Opened:
          </td>
          <td className="text-right"><strong><NumberDisplay value={step.opened} precision={0} /></strong></td>
          <td className="text-right"><NumberDisplay value={openRates} precision={1} suffix="%" /></td>
        </tr>
      ));
      rows.push((
        <tr key={`${step.id}-completed`}>
          <td>
            Provided:
          </td>
          <td className="text-right"><strong><NumberDisplay value={step.completed} precision={0} /></strong></td>
          <td className="text-right"><NumberDisplay value={completeRates} precision={1} suffix="%" /></td>
        </tr>
      ));
      rows.push((
        <tr key={`${step.id}-space`}>
          <td colSpan={3}>&nbsp;</td>
        </tr>
      ));
    });

    let successRates = 0;
    if (firstStep.terminated !== undefined) {
      successRates = totalTerminate !== 0 ? (totalComplete / totalTerminate) * 100 : 0;
    } else {
      successRates = firstStep.total !== 0 ? (totalComplete / firstStep.total) * 100 : 0;
    }

    const tip = (
      <Tooltip id="feedback-rates">
        <div>
          Percentage of contacts that have provided feedback.
        </div>
      </Tooltip>
    );
    return (
      <div>
        {nav}
        <table className="table table-condensed" style={{ margin: 0 }}>
          <thead>
            <tr>
              <th colSpan={3}>
                <h5>
                  <strong>
                    Success Rate:
                    {' '}
                    <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={tip}>
                      <span style={{ cursor: 'pointer' }}><span style={{ cursor: 'pointer' }} className="text-success"><NumberDisplay value={successRates} precision={1} suffix="%" /></span> <Fa name="info-circle" className="text-active" /></span>
                    </OverlayTrigger>
                  </strong>
                </h5>
              </th>
            </tr>
          </thead>
          <tbody>
            {rows}
          </tbody>
        </table>
      </div>
    );
  }
}

CollectorStats.propTypes = {
  dispatch: PropTypes.func.isRequired,
  collector: PropTypes.shape({
    collector_id: PropTypes.string.isRequired,
  }).isRequired,
  shouldFetch: PropTypes.bool,
  loading: PropTypes.bool,
  loaded: PropTypes.bool,
  data: PropTypes.shape({}),
  requestFetchCollectorStats: PropTypes.func,
};
CollectorStats.defaultProps = {
  shouldFetch: false,
  loading: false,
  loaded: false,
  requestFetchCollectorStats: () => {},
  data: {},
};

// Retrieve data from store as props
function mapStateToProps(state, ownProps) {
  const { collector } = ownProps;
  const collectorId = collector.collector_id;

  const loading = getCollectorStatsLoading(state, collectorId);
  const loaded = getCollectorStatsLoaded(state, collectorId);
  const data = getCollectorStatsData(state, collectorId);
  const shouldFetch = !loading && !loaded;

  return {
    data,
    loading,
    loaded,
    shouldFetch,
  };
}

export default connect(mapStateToProps)(CollectorStats);
